import React, { useEffect, useCallback, useState } from 'react'
// react redux
import { connect } from "react-redux";

// themes
import Theme1 from "./Themes/Theme1";

// custom hooks
import useQueryHook from 'utlis/CustomHooks/useQueryHook';

// API
import { getCategories, cancelGetCategoriesApi } from 'utlis/Apis/Categories_API';


function Categories(props) {
    // props
    const {
        commonToken,
        globalAppTheme,
        match
    } = props

    // consts
    const query = useQueryHook()

    // states
    const [categoriesListLoading, setCategoriesListLoading] = useState(false)
    const [categoriesList, setCategoriesList] = useState([])
    const [categoryId, setCategoryId] = useState(null)
    const [categoryName, setCategoryName] = useState(null)
    const [currentRoute, setCurrentRoute] = useState({}); // { routeName: 'name of the route', routeUrl: 'url of the route' }

    // function to get categoris
    const getUniqueCategories = useCallback((catId, catName) => {
        if (catId && catName) {
            // showing loading
            setCategoriesListLoading(true)

            const urlPrams = `parent_id=${catId}&page=0`
            getCategories(commonToken ?? "", urlPrams).then(res => {
                const resData = res.data

                // hiding loading
                setCategoriesListLoading(false)

                // if request is success
                if (resData.success) {
                    // console.log("resData success ", resData);
                    // setting categories list
                    setCategoriesList(resData.data)
                }

                // if request is error
                if (resData.error) {
                    console.log("resData error ", resData);
                }
            }).catch(err => {
                console.log("err ", err);

                // hiding loading
                setCategoriesListLoading(false)
            })
        }
    }, [commonToken])

    // setting categories details
    useEffect(() => {
        const catId = query.get('id')
        const catName = match?.params?.catName
        if (catId && catName) {
            setCategoryId(catId)
            setCategoryName(catName)
        }
    }, [query, match])

    // getting categories
    useEffect(() => {
        getUniqueCategories(categoryId, categoryName)
    }, [getUniqueCategories, categoryId, categoryName])

    // breadcrumbs generating
    useEffect(() => {
        // setting current route
        if (categoryId && categoryName) {
            setCurrentRoute({
                routeName: categoryName,
                sku: categoryName,
                routeUrl: "/shop/" + categoryName + "?id=" + categoryId,
            });
        }
    }, [categoryId, categoryName]);

    return (
        <React.Fragment>
            {
                globalAppTheme === 'theme1' ? (
                    <Theme1
                        currentRoute={currentRoute}
                        categoriesListLoading={categoriesListLoading}
                        categoriesList={categoriesList}
                    />
                ) : null
            }
        </React.Fragment>
    );
}

const getDataFromStore = (state) => {
    return {
        globalAppTheme: state.common.globalAppTheme,
        commonToken: state.auth.commonToken,
    };
};

// const dispatchActionsToProps = (dispatch) => {
//     return {};
// };

export default connect(getDataFromStore, null)(Categories);